export default "__VITE_ASSET__ByQUH0uf__"